import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slugify',
  standalone: true
})

export class SlugifyPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return value
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '')
      .trim();
  }

}
